import { CreateNewDeviceMenuItem, MergeDevicesMenuItem } from "./components";

export function HeaderMenuItem() {
  return <></>;
}

HeaderMenuItem.CreateNewDevice = CreateNewDeviceMenuItem;
HeaderMenuItem.MergeDevices = MergeDevicesMenuItem;
